import { Component } from "@angular/core";

@Component({
  selector: "app-shine-animation",
  template: "",
  styleUrls: ["./shine-animation.component.scss"],
})
export class ShineAnimationComponent {}
